import { SxStyleProp } from "theme-ui"

export const root: SxStyleProp = {
  listStyle: "none",
  mb: 0,
  p: 0,
  display: "flex",
}
